import { render, staticRenderFns } from "./PatentHistoryForm.vue?vue&type=template&id=4f3316e2&"
import script from "./PatentHistoryForm.vue?vue&type=script&lang=js&"
export * from "./PatentHistoryForm.vue?vue&type=script&lang=js&"
import style0 from "./PatentHistoryForm.vue?vue&type=style&index=0&id=4f3316e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports